import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchGrowthOffers } from "../api/growthOffers";
import { customerIdOf } from "./useAnalyticsUser";

/* One request per signed-in identity per page load, shared by every caller. */
const offersRequests = new Map();

const offersFor = (customerId) => {
  const key = customerId || "guest";
  if (!offersRequests.has(key)) {
    offersRequests.set(
      key,
      fetchGrowthOffers().catch(() => {
        offersRequests.delete(key);
        return null;
      })
    );
  }
  return offersRequests.get(key);
};

/**
 * useGrowthOffers: what the server says this shopper is offered right now
 * (first-order free delivery, referral, and the one offer to advertise). null
 * until known or when the server does not offer anything; callers then show
 * nothing.
 */
export default function useGrowthOffers() {
  const customerId = useSelector((state) => customerIdOf(state.user?.currentUser));
  const [offers, setOffers] = useState(null);
  useEffect(() => {
    let active = true;
    offersFor(customerId).then((result) => {
      if (active) setOffers(result || null);
    });
    return () => {
      active = false;
    };
  }, [customerId]);
  return offers;
}

/*
 * The free delivery worth telling this shopper about is the SERVER's answer,
 * `offerToShow` on GET /api/growth/offers ({ kind, cap, signedIn } or null):
 * a signed-in customer's own next-order entitlement, or for a guest the
 * first-order offer while it is on. Read it as returned; nothing here decides.
 */
export const offerToShowOf = (offers) => offers?.offerToShow || null;

export const referralOpen = (offers) => Boolean(offers?.referral?.enabled);
